import { parse } from "date-fns";

import { dateFormat } from "./constants";

export function parseDate(
  dateString: string,
  format: string = dateFormat,
  referenceDate: Date | number = new Date(),
): Date {
  if (parseDate.cache[dateString]) {
    return parseDate.cache[dateString];
  }
  parseDate.cache[dateString] = parse(dateString, format, referenceDate);
  return parseDate.cache[dateString];
}
parseDate.cache = {} as Record<string, Date>;
